<script>
import { buildRRClickHandler } from '@rei/recommendations';
import CategoryRecommendations from '@rei/category-recs';
import { CdrText, CdrLink } from '@rei/cedar';

import getRecs from '../../utils/recommendations';
import metrics from '../../mixins/metrics';

export default {
  name: 'CategoryRecsComponent',
  components: {
    CdrText,
    CdrLink,
    CategoryRecommendations,
  },
  mixins: [metrics],
  props: {
    shopThisStoreModel: { type: Object, required: true },
    storeNumber: { type: String, required: true },
  },
  data() {
    return {
      recsPlacement: null,
      shopThisStoreTitle: 'Shop this store',
      seeAllProductsLink: 'See all products at this store',
    };
  },
  computed: {
    recsEnabled() {
      const { shopThisStoreModel: { enabled } } = this;
      return enabled;
    },
    rrClickHandler() {
      return buildRRClickHandler(this.richRelevanceShopThisStoreMetricsClick);
    },
    recs() {
      const { recsPlacement, storeNumber } = this;
      const { shopThisStoreModel: { numRecommendations } } = this;

      if (recsPlacement && recsPlacement.length > 0) {
        const { recsItems } = recsPlacement[0];

        if (Array.isArray(recsItems)) {
          // Override categories links to a specific store.
          const items = recsItems.map((item) => ({
            ...item,
            href: `${item.href}?r=stores:${storeNumber}&fx=stores:${storeNumber}`,
          }));

          return {
            limit: Number(numRecommendations),
            items,
          };
        }
      }
      return null;
    },
    recsLink() {
      return this.shopThisStoreModel.link.href;
    },
  },
  async mounted() {
    await this.getRecommendations();
  },
  methods: {
    async getRecommendations() {
      const { shopThisStoreModel: { placementType, numRecommendations } } = this;
      this.recsPlacement = await getRecs([{ placementType, numRecommendations }], 'home');
    },
    handleClickEvent(config) {
      if (window.metrics) {
        this.rrClickHandler(config);
      }
    },
  },
};
</script>

<template>
  <div
    v-if="recsEnabled && recs"
  >
    <div
      data-ui="rr-shop-this-store"
      aria-label="recommendations"
      class="shop-this-store"
    >
      <div class="shop-this-store__heading">
        <cdr-text
          class="shop-this-store__title"
          data-ui="shop-this-store-title"
          tag="h2"
        >
          {{ shopThisStoreTitle }}
        </cdr-text>
        <cdr-link
          v-if="shopThisStoreModel.link.enabled"
          :href="recsLink"
          data-ui="shop-this-store-link"
          class="shop-this-store__link"
          rel="nofollow"
          @click="metricsClick('Shop this Store_See all products at this store', null)"
        >
          {{ seeAllProductsLink }}
        </cdr-link>
      </div>

      <category-recommendations
        data-ui="shop-this-store-recommendation"
        :items="recs.items"
        :display-message="false"
        :limit="recs.limit"
        placement-name="shop-this-store"
        @category-click="handleClickEvent"
      />
    </div>
  </div>
</template>

<style lang="scss">
@import "@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss";

.shop-this-store {
  margin-top: $cdr-space-two-x;
  @include cdr-container;
  &__heading {
    @include cdr-md-mq-up {
      display: flex;
    }
  }

  &__title {
    @include cdr-text-heading-serif-500;
    margin-right: $cdr-space-one-x;
  }
}

@media screen and (min-width: $cdr-breakpoint-sm) {
  .shop-this-store {
    &__heading {
      flex-direction: row;
    }

    &__title {
      @include cdr-text-heading-serif-600;
    }
  }
}

@media screen and (min-width: $cdr-breakpoint-md) {
  .shop-this-store {
    margin-top: $cdr-space-four-x;

    &__heading {
      margin-bottom: $cdr-space-two-x;
    }

    &__title {
      @include cdr-text-heading-serif-700;
    }
  }
}
</style>
